"use client"

import styled from "@emotion/styled"
import Image from "next/image"
import { Desktop, Mobile, NewText } from "ui"
import { extractProperty, extractPropertyMediaItems, getUmbracoMediaUrl } from "utils"

const StyledKeyFeatures = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 16px;
  column-gap: 24px;
  padding-top: 32px;
  padding-bottom: 32px;
  width: 100%;
  justify-items: center;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 16px;
    grid-template-columns: repeat(4, max-content);
    justify-items: unset;
  }
`

const StyledKeyFeature = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-direction: column;
  width: calc(50% - 16px);
  ${(props) => props.theme.breakpoints.up("md")} {
    max-width: 112.75px;
    width: unset;
  }
`

function KeyFeaturesBlock({ data }: { data: any }) {
  const productKeyFeatures = extractProperty(data, "productKeyFeatures")?.map((feature: any) => {
    return {
      icon: extractPropertyMediaItems(feature, "icon")?.[0],
      text: extractProperty(feature, "text"),
    }
  })
  return (
    productKeyFeatures?.length > 0 && (
      <StyledKeyFeatures>
        {productKeyFeatures?.map((feature: any, index: number) => {
          return (
            <StyledKeyFeature key={index}>
              <Mobile>
                <Image
                  src={getUmbracoMediaUrl(feature.icon)}
                  alt={feature.text}
                  width={20}
                  height={20}
                  style={{ objectFit: "contain" }}
                />
              </Mobile>
              <Desktop>
                <Image
                  src={getUmbracoMediaUrl(feature.icon)}
                  alt={feature.text}
                  width={30}
                  height={30}
                  style={{ objectFit: "contain" }}
                />
              </Desktop>
              <NewText
                key={index}
                component="h2"
                desktopFontSize={18}
                desktopFontWeight={400}
                desktopLineHeight={"100%"}
                mobileFontSize={14}
                mobileFontWeight={400}
                mobileLineHeight={"100%"}
                textAlign="center"
                color="black"
              >
                {feature.text}
              </NewText>
            </StyledKeyFeature>
          )
        })}
      </StyledKeyFeatures>
    )
  )
}
export default KeyFeaturesBlock
